import { useMemo } from 'react';
import { Insights } from '../../../types/Insights';
import { DonutChartData } from '@silverfort/sf-components';

const MINIMUM_VALUE = 0.1;

const useSecurityExposures = (insights: Insights, isEmpty: boolean): DonutChartData[] => {
    return useMemo(() => {
        const totalProtected = insights.totalProtectedUsers || 1;

        if (isEmpty) {
            return [];
        }

        return [
            {
                name: 'Paired',
                value: insights.totalPairedUsers,
                fill: '#FFAF39',
                formattedValue: `${Math.max(
                    Math.floor((insights.totalPairedUsers / totalProtected) * 100),
                    MINIMUM_VALUE
                )}%`,
                tooltipContent: `Paired users: ${insights.totalPairedUsers}`
            },
            {
                name: 'Pending',
                value: insights.totalPendingUsers,
                fill: '#FF115B',
                formattedValue: `${Math.max(
                    Math.floor((insights.totalPendingUsers / totalProtected) * 100),
                    MINIMUM_VALUE
                )}%`,
                tooltipContent: `Pending users: ${insights.totalPendingUsers}`
            },
            {
                name: 'Excluded',
                value: insights.totalExcludedUsers,
                fill: '#FBDF40',
                formattedValue: `${Math.max(
                    Math.floor((insights.totalExcludedUsers / totalProtected) * 100),
                    MINIMUM_VALUE
                )}%`,
                tooltipContent: `Excluded users: ${insights.totalExcludedUsers}`
            },
            {
                name: 'Unpaired',
                value: insights.totalUnpairedUsers,
                fill: '#50017A',
                formattedValue: `${Math.max(
                    Math.floor((insights.totalUnpairedUsers / totalProtected) * 100),
                    MINIMUM_VALUE
                )}%`,
                tooltipContent: 'Unpaired users: ' + insights.totalUnpairedUsers
            }
        ];
    }, [insights]);
};

export default useSecurityExposures;
